<template>
  <footer class="footer">
    <div class="container">
      <div class="row mb-5">
        <div class="col-md">
          <div class="mb-4 t-a-c">
            <h2 class="title">
              About
              <span>Business Debt Adjusters</span>
            </h2>
            <p>Business Debt Adjusters is a debt settlement agency offering debt relief services throughout the US. For almost a decade, the company has been helping small business owners get rid of their Merchant Cash Advances and other commercial debts. The company has already helped more than 2,000 businesses become debt-free.</p>
          </div>
        </div>
        <div class="col-md">
          <div class="mb-4 ml-md-4 t-a-c">
            <h2 class="title">Links</h2>
            <b-navbar-nav variant="dark" class="ml-auto">
              <b-nav-item to="/">Home</b-nav-item>
              <b-nav-item-dropdown toggle-class="text-light" text="About Us">
                <b-dropdown-item to="/whoWeAre">Who We Are</b-dropdown-item>
                <b-dropdown-item to="/whatWeOffer">What We Offer</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item to="/faqs">FAQs</b-nav-item>
              <b-nav-item to="/ourTeam">Our Team</b-nav-item>
              <b-nav-item to="/blog">Blog</b-nav-item>
              <b-nav-item to="/contact">Contact Us</b-nav-item>
            </b-navbar-nav>
          </div>
        </div>
        <div class="col-md">
          <div class="mb-4 t-a-c">
            <h2 class="title">Have a Question?</h2>
            <div class="mb-0">
              <ul style="padding: 0;">
                <li>
                  <i class="fas fa-map-marker-alt"></i>
                  <span class="text">120 Sylvan Ave, Englewood Cliffs, NJ 07632</span>
                </li>
                <li>
                  <a class="footer_phone" href="tel:877-817-0404">
                    <i class="fas fa-phone"></i>
                    <span class="text">Phone number: (877) 817‑0404</span>
                  </a>
                </li>
                <li>
                  <a href="mailto: info@businessdebtadjusters.com">
                    <span>
                      <i class="fas fa-envelope"></i>
                    </span>
                    <span class="text">info@businessdebtadjusters.com</span>
                  </a>
                </li>
              </ul>
            </div>
            <h2 class="follow_us_footer">Follow us</h2>
            <ul class="float-md-left float-lft mt-4" style="padding: 0; width: 100%;">
              <li class="ftco-animate">
                <a href="#">
                  <span>
                    <i class="fab fa-twitter"></i> twitter
                  </span>
                </a>
              </li>
              <li class="ftco-animate">
                <a href="#">
                  <span>
                    <i class="fab fa-facebook"></i> facebook
                  </span>
                </a>
              </li>
              <li class="ftco-animate">
                <a href="#">
                  <span>
                    <i class="fab fa-google-plus"></i> google+
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>
            Copyright &copy;
            2020 All rights reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.t-a-c {
  text-align: center !important;
}
.follow_us_footer {
  margin: 0 auto;
  padding: 0;
  width: 100%;
  margin-top: 0 !important;
}
.footer {
  background: #222831;
  padding: 50px 0;
  color: #fff;
  line-height: 1.8;

  .text {
    margin-left: 10px;
  }
  ul {
    list-style: none;
  }
  a {
    color: rgba(255, 255, 255, 1) !important;
    &:hover {
      text-decoration: none;
      color: rgba(255, 255, 255, 0.7) !important;
    }
  }

  .title {
    color: #fff;
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: 600;

    span {
      color: #aebaff;
      font-size: 22px !important;
    }
  }
}
</style>